import { StarIcon } from '@heroicons/react/24/solid';
import { Link } from 'gatsby';
import React, { useState } from 'react';
import call_icon from '../../assets/call_icon.svg';
import menu_icon from '../../assets/menu_icon.svg';
import { StylableProp } from '../../utils/stylable-prop';
import NuborrowLogo from '../NuborrowLogo/NuborrowLogo';
import SideMenu from './SideMenu';

const openNextPage = () => {
  window.location.href = 'https://products.nuborrow.com/';
};

export default function Header(props: StylableProp) {
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  return (
    <header
      className={`font-raleway fixed z-50 w-full bg-white shadow-md ${props.shadow}`}
      onClick={() => isOpenMenu && setIsOpenMenu(!isOpenMenu)}
    >
      <div className={`container flex items-center justify-between p-4  ${props.className}`}>
        <NuborrowLogo className="h-5 w-auto md:h-8 lg:h-10" />
        <div className="flex items-center justify-center gap-10 text-sm font-medium lg:w-1/2 xl:justify-end ">
          <>
            <Link to="/buy" className="hidden cursor-pointer hover:text-brand lg:block">
              Buy
            </Link>
            <Link to="/refinance" className="hidden cursor-pointer hover:text-brand lg:block">
              Refinance
            </Link>
            <Link
              to="/home-equity-loan"
              className="hidden cursor-pointer hover:text-brand lg:block"
            >
              Home Equity Loan
            </Link>
            <Link
              to="/home-equity-line"
              className="hidden cursor-pointer hover:text-brand lg:block"
            >
              Home Equity Line
            </Link>
          </>
        </div>

        {/* <div className="google-logo">
          <div className="logo flex gap-2">
            <img className="h-6 md:h-8 lg:h-10" src={LogoGoogle} alt="Google Logo" />
            <span className="stars flex text-yellow-400">{renderStar(5)}</span>
          </div>
          <div className="desc text-center text-xs text-slate-600 md:text-sm lg:text-base">
            <span>1000s of online reviews</span>
          </div>
        </div> */}

        <div className="flex items-center justify-end ">
          <div className="hidden items-center gap-2 text-sm font-medium text-brand lg:flex">
            <img src={call_icon} alt="callIcon" />
            <a href="tel:1 888 372 5588">
              1 888 372 5588
              {/* <span className="ml-3 mr-1 mt-1">1</span>888 <span className="ml-1 mt-1">372 55</span>
              88 */}
            </a>
          </div>
          <button
            className="ml-8 hidden w-24 rounded-full border-2 bg-brand py-2 text-xs font-medium text-white duration-300 hover:border-brand hover:bg-white hover:text-brand lg:block lg:w-44 lg:py-4  lg:text-sm"
            onClick={() => (window.location.href = 'http://apply.nuborrow.com/')}
          >
            Apply Now
          </button>
          <div className="lg:hidden" onClick={() => setIsOpenMenu(true)}>
            <img src={menu_icon} alt="manue" />
          </div>
          {isOpenMenu && <SideMenu setIsOpenMenu={setIsOpenMenu} />}
        </div>
      </div>
    </header>
  );
}

const renderStar = (count: number) => {
  const output: JSX.Element[] = [];

  for (let i = 0; i < count; i++) {
    output.push(<StarIcon key={`star-${i}`} className="w-3 md:w-4 lg:w-6" />);
  }

  return output;
};
